import React, { FC } from 'react';
import { Link as ChakraLink, Text, Box } from '@chakra-ui/react';
import { motion } from 'framer-motion';

const MotionBox = motion(Box);

interface AnimatedLinkProps {
    to: string;
    children: React.ReactNode;
    isActive?: boolean;
    onClick?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
}

const AnimatedLink: FC<AnimatedLinkProps> = ({ to, children, isActive, onClick }) => {

    const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        e.preventDefault();
        const el = document.getElementById(to);
        if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        if (onClick) onClick(e);
    };

    return (
        <ChakraLink
            as="a"
            href={`#${to}`}
            position="relative"
            color={isActive ? 'color.500' : 'gray.700'}
            fontWeight="medium"
            textTransform="uppercase"
            _hover={{ color: 'color.500', transition: 'color 0.3s ease' }}
            onClick={handleClick}
        >
            <Text>{children}</Text>

            {isActive && (
                <MotionBox
                    position="absolute"
                    bottom="0"
                    left="0"
                    height="2px"
                    bg="color.500"
                    initial={{ width: 0 }}
                    animate={{ width: '100%' }}
                    transition={{ duration: 0.4, ease: 'easeInOut' }}
                    borderRadius="full"
                />
            )}
        </ChakraLink>
    );
};

export default AnimatedLink;
